import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Grid,
} from "@mui/material";
import ZoneGroupIcon from "./ZoneGroupIcon";

// Styles found in deviceControlStyles.js

const ControlCardSelector = ({
  zone,
  t,
  getButtonStatus,
  isButtonDisabled,
  handleButtonClick,
  getButtonBackgroundColor,
  buttonStyles,
  selectionMode,
  onEnableSelectionMode,
  onCancelSelectionMode,
  selectedCount = 0,
}) => {
  const buttonStatus = getButtonStatus(zone);
  const disabled = isButtonDisabled(zone);
  const multiCleanStartColor = "#60e266";

  return (
    <Grid item key="selector">
      <Card
        sx={{
          height: 184,
          width: 184,
          display: "flex",
          flexDirection: "column",
          border: selectionMode ? "2px solid #1976d2" : "2px solid transparent",
          boxShadow: selectionMode ? 6 : 1,
        }}
      >
        <CardContent
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            p: 1.5,
          }}
        >
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            sx={{
              fontSize: "0.92rem",
              fontWeight: "bold",
              textAlign: "center",
              flexGrow: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 1.5,
            }}
          >
            <ZoneGroupIcon
              groupName={zone.nameEn}
              displayName={zone.name}
              size={18}
              sx={{ mr: 1 }}
            />
            {t("multiClean").toUpperCase()}
          </Typography>

          {selectionMode ? (
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => handleButtonClick(zone.id, zone.name, "start")}
                disabled={selectedCount < 2}
                sx={{
                  ...buttonStyles.base,
                  backgroundColor:
                    selectedCount < 2 ? "#9e9e9e" : multiCleanStartColor,
                  "&:hover": {
                    backgroundColor:
                      selectedCount < 2 ? "#9e9e9e" : multiCleanStartColor,
                    ...buttonStyles.hover,
                  },
                }}
              >
                Start
              </Button>
              <Button
                variant="outlined"
                fullWidth
                onClick={onCancelSelectionMode}
                sx={{
                  ...buttonStyles.base,
                  backgroundColor: getButtonBackgroundColor("stop"),
                  "&:hover": {
                    backgroundColor: getButtonBackgroundColor("stop"),
                    ...buttonStyles.hover,
                  },
                }}
              >
                {t("buttonStatus.cancel").toUpperCase()}
              </Button>
            </Box>
          ) : buttonStatus === "paused" ? (
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="outlined"
                fullWidth
                disabled={disabled}
                onClick={() => handleButtonClick(zone.id, zone.name, "stop")}
                sx={{
                  ...buttonStyles.base,
                  backgroundColor: disabled
                    ? "#9e9e9e"
                    : getButtonBackgroundColor("stop"),
                  "&:hover": {
                    backgroundColor: disabled
                      ? "#9e9e9e"
                      : getButtonBackgroundColor("stop"),
                    ...buttonStyles.hover,
                  },
                }}
              >
                {t("buttonStatus.stop")}
              </Button>
              <Button
                variant="outlined"
                fullWidth
                disabled={disabled}
                onClick={() => handleButtonClick(zone.id, zone.name, "resume")}
                sx={{
                  ...buttonStyles.base,
                  backgroundColor: disabled
                    ? "#9e9e9e"
                    : getButtonBackgroundColor("resume"),
                  "&:hover": {
                    backgroundColor: disabled
                      ? "#9e9e9e"
                      : getButtonBackgroundColor("resume"),
                    ...buttonStyles.hover,
                  },
                }}
              >
                {t("buttonStatus.resume")}
              </Button>
            </Box>
          ) : (
            <Button
              variant="outlined"
              fullWidth
              disabled={disabled}
              onClick={() => {
                if (buttonStatus === "start") {
                  onEnableSelectionMode();
                  return;
                }

                handleButtonClick(zone.id, zone.name, buttonStatus);
              }}
              sx={{
                ...buttonStyles.base,
                backgroundColor: disabled
                  ? "#9e9e9e"
                  : buttonStatus === "start"
                    ? multiCleanStartColor
                    : getButtonBackgroundColor(buttonStatus),
                "&:hover": {
                  backgroundColor: disabled
                    ? "#9e9e9e"
                    : buttonStatus === "start"
                      ? multiCleanStartColor
                      : getButtonBackgroundColor(buttonStatus),
                  ...buttonStyles.hover,
                },
              }}
            >
              {buttonStatus === "start"
                ? t("buttonStatus.select").toUpperCase()
                : t(`buttonStatus.${buttonStatus}`)}
            </Button>
          )}
        </CardContent>
      </Card>
    </Grid>
  );
};

export default ControlCardSelector;
